import React from 'react';
import { useAlgoliaSearch } from '../hooks/useAlgoliaSearch';
import { DataContext, DataStateContext } from './Data.context';
export const AlgoliaDataProvider = ({ children }) => {
    const [data, dataState] = useAlgoliaSearch();
    return (React.createElement(DataContext.Provider, { value: data },
        React.createElement(DataStateContext.Provider, { value: dataState }, children)));
};
